<template>
  <div class="flex flex-col overflow-y-auto">
    <div class="d-block text-center mb-2">
      <span class="font-weight-bold">{{ $t('ct-checkout-gateway-pagseguro-exclusive-info') }}</span>
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex">
          <button class="btn btn-outline-info" :class="{'active': !config.sandbox}" @click="config.sandbox = false">{{ $t('ct-production') }}</button>
          <button class="btn btn-outline-info" :class="{'active': config.sandbox}" @click="config.sandbox = true">{{ $t('ct-sandbox') }}</button>
        </div>
        <div v-if="!config.sandbox">
          <h5>{{ $t('ct-checkout-gateway-pagseguro-making-sales') }}</h5>
          <ul class="lg:mb-0 list-disc mb-5 ml-5">
            <li>{{ $t('ct-checkout-gateway-pagseguro-making-sales-1') }}</li>
            <li>{{ $t('ct-checkout-gateway-pagseguro-acess-page-here') }} <a class="underline" target="_blank" href="https://pagseguro.uol.com.br/">
            https://pagseguro.uol.com.br </a></li>
            <li>{{ $t('ct-checkout-gateway-pagseguro-making-sales-2') }}</li>
            <li>{{ $t('ct-checkout-gateway-pagseguro-making-sales-3') }}</li>
            <li>{{ $t('ct-checkout-gateway-pagseguro-making-sales-4') }}</li>
            <li>{{ $t('ct-checkout-gateway-pagseguro-making-sales-5') }}</li>
          </ul>
        </div>
        <div v-if="config.sandbox">
          <h5>{{ $t('ct-checkout-gateway-pagsegur-making-tests') }}</h5>
          <ul class="lg:mb-0 list-disc mb-5 ml-5">
            <li>{{ $t('ct-checkout-gateway-pagseguro-making-tests-1') }}</li>
            <li>{{ $t('ct-checkout-gateway-pagseguro-acess-page-here') }} <a class="underline" target="_blank" href="https://sandbox.pagseguro.uol.com.br/">
              https://sandbox.pagseguro.uol.com.br </a></li>
            <li>{{ $t('ct-checkout-gateway-pagseguro-making-tests-2') }}</li>
            <li>{{ $t('ct-checkout-gateway-pagseguro-making-tests-3') }}</li>
            <li>{{ $t('ct-checkout-gateway-pagseguro-making-tests-4') }}</li>
            <li>{{ $t('ct-checkout-gateway-pagseguro-making-tests-5') }}.</li>
            <li>{{ $t('ct-checkout-gateway-pagseguro-making-tests-6') }}</li>
          </ul>
        </div>
      </div>
      <div class="col">
        <!-- Input Description -->
        <div class="form-group">
            <label for="description" class=" control-label">{{ $t('ct-description') }}</label>
            <div class="" :class="{'has-error': e.has('name')}">
                <input type="text" class="form-control" id="description" name="description" v-model="config.name">
                <span class="label label-danger" v-if="e.has('name')">{{ e.first('name') }}</span>
            </div>
        </div>
        <!-- Input Email -->
        <div class="form-group">
            <label for="email" class=" control-label">{{ $t('ct-email') }}</label>
            <div class="" :class="{'has-error': e.has('email')}">
                <input type="text" class="form-control" id="email" name="email" v-model="config.email">
                <span class="label label-danger" v-if="e.has('email')">{{ e.first('email') }}</span>
            </div>
        </div>
        <!-- Input Token -->
        <div class="form-group">
            <label for="token" class=" control-label">{{ $t('ct-token') }}</label>
            <div class="" :class="{'has-error': e.has('token')}">
                <input type="text" class="form-control" id="token" name="token" v-model="config.token">
                <span class="label label-danger" v-if="e.has('token')">{{ e.first('token') }}</span>
                <span class="label label-danger" v-if="e.has('keys')">{{ e.first('keys') }}</span>
            </div>
        </div>

        <!-- Input Sandbox -->
        <div class="form-group">
          <label for="boleto" class=" control-label">{{ $t('ct-checkout-gateway-pagseguro-create-boleto') }}</label>
          <div class="" :class="{'has-error': e.has('boleto')}">
            <input type="checkbox" id="boleto" name="boleto" v-model="config.boleto">
          </div>
        </div>
        <!-- Input Insurance -->
        <div class="form-group" v-if="config.boleto">
            <label for="insurance" class=" control-label">{{ $t('ct-checkout-gateway-pagseguro-enable-ticket') }}</label>
            <div class="" :class="{'has-error': e.has('insurance')}">
                <input type="checkbox" id="insurance" name="insurance" v-model="config.enableTicketInsurance">
            </div>
        </div>

      </div>
    </div>
    <!-- Form Submit -->
    <div class="form-group">
      <div class="col-sm-offset-2 col-sm-10">
        <button class="btn btn-default" @click="$emit('cancel')">{{ $t('ct-cancel') }}</button>
        <button type="button" class="btn btn-info" @click="save">{{ $t('ct-save') }}</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PagseguroConfig',
  props: ['value', 'e'],

  data() {
    return {
      config: {}
    };
  },

  watch: {
    config: {
      handler(config) {
        this.$emit('input', config);
      },
      deep: true
    },
    'value': function(val) {
      this.$emit('input', this.config);
    }
  },

  methods: {
    save() {
      this.e.clear();
      this.e.addValidation({
        name: 'required',
        email: 'required|email',
        token: 'required'
      });

      this.e.validate(this.config);

      if (!this.e.any()) this.$emit('save', this.config);
    }
  },

  created() {
    this.config = JSON.stringify(this.value) !== '{}' ? this.value : {
      sandbox: false,
      boleto: true,
      enableTicketInsurance: true
    };
    if (typeof this.config.boleto === 'undefined') {
      this.config = {
        boleto: true,
        enableTicketInsurance: true,
        ...this.config
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/GatewayConfig/PagseguroConfig.vue